import React, { useEffect, useState } from 'react';

const allImages = [
  '/slide/1.jpg',
  '/slide/2.jpg',
  '/slide/3.jpg',
  '/slide/4.jpg',
  '/slide/5.jpg',
];

const VISIBLE_CARDS = 1;

const ImageCards = () => {
  const [currentIndexes, setCurrentIndexes] = useState(
    Array(VISIBLE_CARDS).fill(0)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexes((prev) =>
        prev.map((index) => (index + 1) % allImages.length)
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="px-4 py-8">
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-8">
        {currentIndexes.map((imgIndex, cardIndex) => (
          <div
            key={cardIndex}
            className="rounded-xl overflow-hidden shadow-xl w-full 
                       h-72 sm:h-[24rem] md:h-[28rem] lg:h-[32rem] xl:h-[36rem] transition-all duration-500"
          >
            <img
              src={allImages[imgIndex]}
              alt={`Card ${cardIndex + 1}`}
              className="object-cover w-full h-full"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCards;
